 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];


 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 	};


 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		392: 0,
 		279: 0,
 		280: 0,
 		290: 0,
 		339: 0,
 		340: 0,
 		348: 0
 	};



 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"0":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~e39eff3e","1":"vendors~AddClosedAlertIDUseCase~CreateDeviceUseCase~CreateDomestikaFollowUseCase~CreateJWTUserUseCas~19435117","2":"vendors~AddClosedAlertIDUseCase~CurrentUserUseCase~GetAreasCourseUseCase~GetCartCourseUseCase~GetCat~cc70658c","3":"vendors~SendHeaderTrackingUseCase~SendPlayerTrackingUseCase~SendTrackingUseCase","4":"INTERNAL","216":"AddClosedAlertIDUseCase","217":"CreateDeviceUseCase","218":"CreateDomestikaFollowUseCase","219":"CreateJWTUserUseCase","220":"CreateUserLiveSessionUseCase","221":"CurrentUserUseCase","222":"CurrentWithoutRelationshipsUserUseCase","223":"DeleteDeviceUseCase","224":"DeleteFollowUseCase","225":"ENV_CONFIG1","226":"ENV_CONFIG4","227":"ENV_CONFIG5","228":"ENV_CONFIG6","229":"ENV_CONFIG7","230":"FinishUserLiveSessionUseCase","231":"GetAccessTokenUserUseCase","232":"GetAdvanceGDPRStatusUserUseCase","233":"GetAllBlogUseCase","234":"GetAreasCourseUseCase","235":"GetCartCourseUseCase","236":"GetCategoriesCourseUseCase","237":"GetCourseUseCase","238":"GetFinalProjectVideoByCourseIDCourseUseCase","239":"GetGDPRStatusUserUseCase","240":"GetListLiveFeedbackQuestionUseCase","241":"GetListLiveSessionUseCase","242":"GetListLiveStreamUseCase","243":"GetLiveChannelUseCase","244":"GetLiveSessionUseCase","245":"GetOrganizationUseCase","246":"GetPlusPromotionUseCase","247":"GetPostContentBlogUseCase","248":"GetPromotionCodeAlertUseCase","249":"GetPromotionUseCase","250":"GetPubnubCredentialsUseCase","251":"GetSessionDataUserUseCase","252":"GetSimpleUserUseCase","253":"GetSoftwaresCourseUseCase","254":"GetUserAlertUseCase","255":"GetVideoProgressListCourseUseCase","256":"GetVideoSpeedUserUseCase","257":"GetVideoVolumeUserUseCase","258":"LogoutUserUseCase","259":"PathToRegexp","260":"RefreshAccessTokenUserUseCase","261":"RemoveAccessTokenUserUseCase","262":"SearchCourseUseCase","263":"SendHeaderTrackingUseCase","264":"SendLiveFeedbackAnswersUseCase","265":"SendPlayerTrackingUseCase","266":"SendTrackingUseCase","267":"SendVideoProgressCourseUseCase","268":"SetAdvanceGDPRStatusUserUseCase","269":"SetGDPRStatusUserUseCase","270":"SetVideoSpeedUserUseCase","271":"SetVideoVolumeUserUseCase","272":"UpdateLanguageUserUseCase","273":"UpdateLiveSessionUseCase","274":"UpdateVideoAudioAndSubtitlesCourseUseCase","275":"UpdateVideoProgressCourseUseCase","276":"ViewPageTrackingUseCase","347":"vendors~AddClosedAlertIDUseCase","348":"vendors~AmplitudeJS","349":"vendors~SearchCourseUseCase","350":"vendors~ViewPageTrackingUseCase"}[chunkId]||chunkId) + "-" + {"0":"ff11d86575f522feb89b","1":"5c33efdb95d665425af6","2":"6e8f73a2c737d395e6a7","3":"bb0ea68b72445aa7877a","4":"fb712c7999b14f04d405","5":"a576d977d73407f693be","215":"a293197167e43ded0500","216":"13d954070b84cf91b6a2","217":"713f466131d4d849b5f4","218":"2fd3624602515310df55","219":"8ecbb46d09314a9e0acc","220":"d178726234f801763467","221":"4a548fb7b79d8d7b5131","222":"cb6c5cb1796b97b68ce6","223":"05b40ce544c20928d7a8","224":"4ae6b692c5944a8bb5b4","225":"08ae5efa8c606147aaae","226":"2b9aa8a3fc33a861b43b","227":"0a39e1713ada3c85cb53","228":"a5e92828e9be85246e86","229":"714108c490de91a39f74","230":"836bfa81f1c6385e46be","231":"212b2f3b73cf2508eff2","232":"c7fac078c5c8df8eba79","233":"c62784c67ef3d6364859","234":"0dc957640beddf56f42b","235":"f1a313c1207ec8c90d32","236":"70678dd70ae51e338b82","237":"aa0b92f4f4609fa57eff","238":"50e308f8fe8a86120e70","239":"8213186ecbaaced0701d","240":"88334cea3f6a590dcb0a","241":"54f2b8e9a6826f5dda7b","242":"366d3168b958c30ec104","243":"1d1ce459271b43ba83da","244":"7288a83af97c2b80afc0","245":"0ede0af5e3831e0264db","246":"8340df85bca2e4ff8fb9","247":"c8526a3d2e754c88cdc4","248":"e731efdfd4555a28b012","249":"905667d74ba6e9f859dd","250":"1198e73d0955aa1a47aa","251":"cfd34a0a0152b7dfb508","252":"a0ee110c321491552358","253":"f90bdffb9b13f15dffc0","254":"835150dab9d12bb4bdda","255":"0dc967b9bddecbc562c1","256":"83afb368ee85a2416b20","257":"916d1caa162d008ddc0a","258":"b22333c0262e54ff9625","259":"abeaede4bbadec25ff5b","260":"bedc484683ad42c20c30","261":"723ac9b6f68c3fa5526a","262":"86177065577ddd647398","263":"49c3ef352974b885b4d2","264":"990df0bf346cfee738af","265":"02fb068fdf2a0fcb5e64","266":"c7b116e46e7546707a6a","267":"a33b250f7d5c50387157","268":"7602007bb78559a9e782","269":"f19a7ca1b386e172d533","270":"6872003cf7bf9ffaf17f","271":"cb9ec5ef2834b8e55c23","272":"080c2a3aa3bad7293c04","273":"1eaa5e5541561fe26032","274":"b7b69391b0a856a2f7b9","275":"e33836d5f4882d1a8586","276":"efea9d26ec311ae9cfc4","347":"e7d3578d2649b7d4d797","348":"e8596592176ca946ae49","349":"64e3e7b046db3fd50f19","350":"ce32a38ca673a759b7ec","418":"192df8054be1c3935293","420":"d2206897ea73b3afabe7","421":"1affba3f94e45dacad82","639":"dcce2ec1742b9c5fde16","640":"be2f118b9f8bae35ee19","641":"628c79bc9e2a42cfbae4"}[chunkId] + ".chunk.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://cdn.domestika.org/raw/upload/packs/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// Load entry module and return exports
 	return __webpack_require__(__webpack_require__.s = 2190);
